import store, { CoreReduxState } from "@utils/redux/store";
import { isCountryImperial } from "./userSegment";

import { isDynamicPlanGraphEligible } from "./userSegment/features";

export function canShowDynamicPlanGraph(state = store.getState()) {
  return isDynamicPlanGraphEligible(state) && canRetrieveWeight(state);
}

export function canRetrieveWeight(state: CoreReduxState = store.getState()) {
  const { userData } = state;
  if (!userData) return false;
  const surveyAnswers = userData[userData.surveyNameSpace];

  if (isCountryImperial(state)) {
    return !!surveyAnswers?.weight && !!surveyAnswers?.idealWeight;
  }
  return !!surveyAnswers?.weightKg && !!surveyAnswers?.idealWeightKg;
}
